<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <h3>{{ modalTitle }}</h3>
        <form @submit.prevent="submitForm" enctype="multipart/form-data">
          <div class="form-group">
            <label>{{ $t('title') }}</label>
            <input v-model="form.title" type="text" class="form-control" required>
          </div>

          <div class="form-group">
            <label>{{ $t('details') }}</label>
            <textarea v-model="form.details" class="form-control" rows="4"></textarea>
          </div>

          <div class="form-group">
            <label>{{ $t('available_subscription_plan') }}</label>
            <select v-model="form.available_subscription_plan" class="form-control" required>
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
              <option value="one-time">One-time</option>
              <option value="all">All</option>
            </select>
          </div>

          <div class="form-group">
            <label>{{ $t('documents') }}</label>
            <input type="file" @change="handleFileUpload" class="form-control" />
            <div v-if="form.file_path">
              <a :href="form.file_path" target="_blank">Download current file</a>
            </div>
          </div>

          <div class="text-end mt-3">
            <button 
              class="btn btn-primary" 
              type="submit" 
              :disabled="isSubmitting">
              {{ isSubmitting ? $t('saving') + '...' : $t('save') }}
            </button>
            <button class="btn btn-secondary" type="button" @click="$emit('input', false)" :disabled="isSubmitting">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    project: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        title: '',
        details: '',
        available_subscription_plan: 'all',
        documents: null,
        file_path: ''  // existing file link
      },
      isSubmitting: false
    }
  },
  watch: {
    project: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.form = {
            title: newVal.title,
            details: newVal.details,
            available_subscription_plan: newVal.available_subscription_plan,
            documents: null,
            file_path: newVal.documents ? '/' + newVal.documents : ''
          }
        } else {
          this.resetForm()
        }
      }
    }
  },
  computed: {
    modalTitle() {
      return this.project ? 'Edit Project' : 'Add Project'
    }
  },
  methods: {
    resetForm() {
      this.form = {
        title: '',
        details: '',
        available_subscription_plan: 'all',
        documents: null,
        file_path: ''
      }
    },
    handleFileUpload(e) {
      this.form.documents = e.target.files[0]
    },
    submitForm() {
      this.isSubmitting = true
      const url = this.project ? `/projects/${this.project.id}` : '/projects'
      const formData = new FormData()
      for (const key in this.form) {
        if (this.form[key] !== null && key !== 'file_path') formData.append(key, this.form[key])
      }
      if (this.project) formData.append('_method', 'PUT')

      axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(() => {
          this.$emit('input', false)
          this.$emit('saved')
          this.resetForm()
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper {
  width: 500px;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
}
</style>

